import z from 'zod';

import type { PageSeoData } from '@do/svelte-seo';

export abstract class SeoData<SchemaType> {
  protected parsedData: SchemaType;

  constructor(
    protected input: Record<string, any>,
    protected schema: z.ZodType<SchemaType>,
    protected fallbackData: PageSeoData,
    protected commonData: Partial<PageSeoData> = {},
  ) {
    this.parsedData = this.validateInput();
  }

  private validateInput(): SchemaType {
    const parsed = this.schema.safeParse(this.input);

    if (!parsed.success) {
      console.error('SEO Data validation failed:', parsed.error);

      return this.schema.parse({});
    }

    return parsed.data;
  }

  protected abstract buildData(parsed: SchemaType): Partial<PageSeoData>;

  public getSeoConfig(): PageSeoData {
    const specific = this.buildData(this.parsedData);
    const base = Object.keys(specific).length > 0 ? specific : this.fallbackData;

    return { ...base, ...this.commonData };
  }

  protected getPaginatedSeoData({
    page,
    title,
    metaDescription,
  }: {
    page: number;
    title: string;
    metaDescription: string;
  }): PageSeoData {
    if (page <= 1) {
      return {
        title,
        metaDescription,
      };
    }

    return {
      title: `Page - ${page} | ${title}`,
      metaDescription: `Page - ${page} | ${metaDescription}`,
    };
  }
}
